import { render, staticRenderFns } from "./ResumeCustomerOrderModal.vue?vue&type=template&id=00855f6c&scoped=true&"
import script from "./ResumeCustomerOrderModal.vue?vue&type=script&lang=js&"
export * from "./ResumeCustomerOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00855f6c",
  null
  
)

export default component.exports